import {validCssSize} from '../../../helpers'

const RENAME_MAPPER = {
	start: 'flex-start',
	end: 'flex-end',
	center: 'center',
	spaceBetween: 'space-between',
	'last-item-end': 'flex-start',
}

const getAlignValues = ({direction, ...rest}) => {
	const align = RENAME_MAPPER[rest[direction]]
	const hasAlignProperty = align
	return {align, hasAlignProperty}
}

const getWidthProperty = ({horizontalMargin, fullMinusMargin, fullWidth}) => {
	if (fullMinusMargin) return `calc(100% - ${horizontalMargin * 2}px)`
	if (fullWidth) return '100%'
	return undefined
}

const sharedStyles = ({cssWidth, cssHeight, fullWidth, fullHeight, align, grow, width}) => {
	const fullMinusMargin = width?.includes?.('full-minus-margin')
	const horizontalMargin = parseInt(width?.split?.('full-minus-margin-')[1] || 12)
	const styles = {
		width: cssWidth || getWidthProperty({horizontalMargin, fullWidth, fullMinusMargin}),
		height: cssHeight || (fullHeight ? '100%' : undefined),
		justifyContent: align,
		flexGrow: grow && 1,
	}

	if (fullMinusMargin) styles.marginLeft = horizontalMargin
	return styles
}

export const getHorizontal = props => {
	const {vertical, width, height, grow, wrap} = props
	const {align, hasAlignProperty} = getAlignValues(props)
	const fullWidth = width === 'full' || hasAlignProperty
	const fullHeight = height === 'full'

	return {
		...sharedStyles({...props, fullWidth, fullHeight, align}),
		flexDirection: 'row',
		alignItems: vertical || 'center',
		flexShrink: grow ? 'unset' : !!width && 0,
		flexWrap: wrap && 'wrap',
	}
}

export const getVertical = props => {
	const {horizontal, width, height, grow} = props

	const {align, hasAlignProperty} = getAlignValues(props)
	const fullWidth = width === 'full'
	const fullHeight = height === 'full' || hasAlignProperty

	return {
		...sharedStyles({...props, fullWidth, fullHeight, align}),
		flexDirection: 'column',
		alignItems: horizontal || 'flex-start',
		flexShrink: grow ? 'unset' : !!height && 0,
	}
}

export const getDistribution = ({width, height, direction, ...rest}) => {
	const cssWidth = validCssSize(width)
	const cssHeight = validCssSize(height)

	const fn = direction === 'vertical' ? getVertical : getHorizontal
	return fn({width, height, cssWidth, cssHeight, direction, ...rest})
}
